var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('wc-section-title',{attrs:{"title":"Accounting"},scopedSlots:_vm._u([{key:"rightSide",fn:function(){return [_c('invoice-lookup-menu')]},proxy:true}])}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }